import React from "react";
import { Link } from "react-router-dom";
import Props from "prop-types";

class SearchableSelect extends React.Component {
	constructor(props) {
		super(props);
		this.showMenu = this.showMenu.bind(this);
		this.closeMenu = this.closeMenu.bind(this);
		this.state = {
			shown: false,
			selectedItems: Array.isArray(props.value) ? props.value : []
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.multi && this.props.value !== prevProps.value) {
			this.setState({ selectedItems: this.props.value || [] });
		}
	}

	showMenu(event) {
		if (this.props.disabled) return;
		if (this.props.activity) this.props.activity();
		event.preventDefault();
		if (this.props.reset) this.props.reset();
		this.setState({ shown: true, items: [] }, () =>
			document.addEventListener("click", this.closeMenu)
		);
	}

	closeMenu(event) {
		if (!event || (this.dropdownMenu && !this.dropdownMenu.contains(event.target))) {
			this.setState({ shown: false }, () =>
				document.removeEventListener("click", this.closeMenu)
			);
		}
	}

	onChange = () => {
		if (this.props.onChange) this.props.onChange(this.input.value);
	};

	toggleSelect = (item) => {
		this.setState(prev => {
			const exists = prev.selectedItems.find(i => i.value === item.value);
			const selectedItems = exists
				? prev.selectedItems.filter(i => i.value !== item.value)
				: [...prev.selectedItems, item];

			this.props.select(this.props.multi ? selectedItems : item);
			return { selectedItems };
		});
	};

	select = (item) => {
		if (this.props.multi) {
			this.toggleSelect(item);
		} else {
			this.closeMenu();
			this.props.select(item);
		}
	};
	
	toggleSelectAll = () => {
		this.setState(prev => {
			const selectedItems = prev.selectedItems.length === this.props.items.length ? [] : this.props.items;
			this.props.select(selectedItems);
			return { selectedItems };
		});
	}

	render() {
		const isValid = this.props.multi
			? this.state.selectedItems.length > 0
			: !!this.props.value;

		const displayValue = this.props.multi
			? this.state.selectedItems.length
				? `${this.state.selectedItems.length} selected`
				: this.props.placeholder
			: this.props.value
				? this.props.value.label
				: this.props.placeholder;

		return (
			<div ref={ref => this.dropdownMenu = ref} className="selectContainer2" style={{width: '100%'}}>
				{
				 this.props.label ?(
					<div className="floating-top-label">{this.props.label}</div>
				) : this.props.name ? (
					<div className="floating-top-label">{this.props.name}</div>
				) : null}

				<div
					onClick={this.showMenu}
					className={`floating-label ${isValid ? "valid" : ""}`}
					style={this.props.style || {}}
				>
					<p style={{ textAlign: "left" }}>{displayValue}</p>
				</div>

				{this.state.shown && (
					<div className="menu" style={{ zIndex: 111, ...this.props.menuStyle }}>
						<div className="select-input-outer">
							<div className="select-input-wrapper">
								<img src={require("./search.png")} alt="search" />
								<input
									ref={ref => (this.input = ref)}
									onChange={this.onChange}
									type="text"
									placeholder={this.props.placeholder}
								/>
							</div>
						</div>

						<div className="item-container">
							{this.props.add && (
								<Link to={this.props.add.link}>
									<div className="add-button item">
										<img src={require("./plus.png")} alt="plus" />
										<p style={{ fontSize: "12px", display: "flex", alignItems: "center" }}>
											{this.props.add.name}
										</p>
									</div>
								</Link>
							)}

							{this.props.button && (
								<div onClick={() => this.props.button.click()}>
									<div className="add-button item">
										<img src={require("./plus.png")} alt="plus" />
										<p style={{ fontSize: "12px", display: "flex", alignItems: "center" }}>
											{this.props.button.name}
										</p>
									</div>
								</div>
							)}
                            {this.props.multi && this.props.items.length > 0 && <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",padding:"10px"}}>
									<p style={{cursor:"pointer",color:"var(--primary-color)",fontWeight:600,fontSize:12}} onClick={()=>this.toggleSelectAll()}>{this.state.selectedItems.length === this.props.items.length ? "Deselect All" : "Select All"}</p>
							</div>}
							{this.props.items.map((item, index) => (
								<div
									key={index}
									className="item"
									style={{ fontSize: "12px", display: "flex", gap: 8, alignItems: "flex-start" }}
								>
									{this.props.multi && (
										<input
											type="checkbox"
											checked={!!this.state.selectedItems.find(i => i.value === item.value)}
											onChange={() => this.toggleSelect(item)}
											onClick={e => e.stopPropagation()}
										/>
									)}

									<div onClick={() => this.select(item)} style={{ flex: 1 }}>
										{this.props.render ? (
											this.props.render(item)
										) : (
											<>
											<p style={{ fontSize: "12px" }}>{item.label}</p>
											{item.tradeName && <p className="des">{item.tradeName}</p>}
											{item.des && <p className="des">{item.des}</p>}
											{item.address && <p className="des">Address: {item.address}</p>}
											{item.des1 && <p className="des">{item.des1}</p>}
											{item.msme && <p className="des">MSME/Udyam VENDOR : {item.msme}</p>}
											{item.tax && !item.otherRate && !item.individualHufRate && (
												<p className="des">{item.tax}%</p>
											)}
											{item.gstin && <p className="des">GSTIN : {item.gstin}</p>}
											{item.unit && <p className="des">unit : {item.unit}</p>}
											{item.hsn && <p className="des">Hsn No. : {item.hsn}</p>}
											{item.otherRate != null && (
												<p className="des">Other Rate : {item.otherRate}%</p>
											)}
											{item.individualHufRate != null && (
												<p className="des">
													Individual Huf Rate : {item.individualHufRate}%
												</p>
											)}
											</>
										)}
									</div>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		);
	}
}

SearchableSelect.propTypes = {
	value: Props.oneOfType([Props.object, Props.array]),
	add: Props.object,
	placeholder: Props.string.isRequired,
	onChange: Props.func,
	items: Props.array,
	select: Props.func.isRequired,
	multi: Props.bool
};

SearchableSelect.defaultProps = {
	items: [],
	multi: false
};

export { SearchableSelect };
